import { useCallback } from 'react'
import { useErrors } from 'transfix-form/hooks/useErrors'
import { ITaskNamespaces } from 'types/graphqlTypes'
import { useAssignShipmentActiveTasksMutation } from '../../../graphql/AssignShipmentActiveTaskMutation'

export const useAssignShipment = (shipmentId: string, taskNamespace: ITaskNamespaces) => {
  const { errorMessages = [], setErrors } = useErrors()
  const [assignShipment, { loading }] = useAssignShipmentActiveTasksMutation()

  const assignShipmentHandler = useCallback(
    async (selectedRep: string | null) => {
      try {
        if (selectedRep) {
          const response = await assignShipment({
            variables: {
              input: {
                shipmentId,
                taskNamespace,
                assignedToId: selectedRep,
              },
            },
            refetchQueries: ({ data, errors }) =>
              !data?.assignShipmentActiveTasks?.errors?.length && !errors?.length
                ? ['NameSpacedActivelyTaskedShipments', 'ShipmentCETasks']
                : [],
          })
          const { data } = response || {}
          const errors = data?.assignShipmentActiveTasks?.errors

          if (errors?.length) {
            setErrors(errors)
            return false
          }
          return true
        }
      } catch (error) {
        const { graphQLErrors = [] } = error || {}
        setErrors(graphQLErrors)
      }
      return false
    },
    [assignShipment, setErrors, shipmentId, taskNamespace]
  )

  return {
    errorMessages,
    assignShipmentHandler,
    loading,
  }
}
